import { buildTheme } from "../const"
import { setMuiColor } from "../const/baseTheme"
import { type YannColor, primary, secondary } from "../const/colors"

function deleteColor(colors: YannColor) {
  const { contrastText, ...newColors } = colors
  return newColors
}

export const adminTheme = buildTheme(({ palette }) => ({
  palette: {
    branding: setMuiColor(deleteColor(primary)),
    brandingAccent: setMuiColor(deleteColor(secondary)),
    header: {
      containedButton: {
        backgroundColor: palette.common.blueGreen,
        primaryColor: palette.common.white,
        secondaryColor: palette.common.blueGreen2,
        hover: {
          backgroundColor: palette.common.blueGreenDark,
        },
      },
      gradient:
        "linear-gradient(-180deg, rgb(118, 179, 181) 0%, rgb(173, 220, 220) 100%);",
    },
    p3Components: {
      sideNavTitle: palette.common.darkBlue,
    },
    background: {
      default: "#edf5f5",
    },
  },
  components: {
    MuiTabs: {
      styleOverrides: {
        root: {
          "&.header-menu .MuiTab-root:hover": {
            color: palette.primary.dark,
          },
        },
      },
    },
  },
}))
